var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0098C24.8366 32.0098 32 24.8463 32 16.0098C32 7.17321 24.8366 0.00976562 16 0.00976562C7.16344 0.00976562 0 7.17321 0 16.0098C0 24.8463 7.16344 32.0098 16 32.0098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0098C21.5652 17.4011 19.0736 20.8793 16 20.8793C12.9264 20.8793 10.4348 17.4011 10.4348 16.0098C10.4348 12.9361 12.9264 10.4446 16 10.4446C19.0736 10.4446 21.5652 12.9361 21.5652 16.0098Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0098C21.5652 19.0834 19.0736 21.575 16 21.575C12.9264 21.575 10.4348 19.0834 10.4348 16.0098",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 20.929L23.3739 19.4535L24.3576 20.4371L22.8821 21.9126L21.8984 20.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4386 23.3882L20.9141 21.9127L21.8977 22.8964L20.4223 24.3718L19.4386 23.3882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 23.8799L26.3251 22.4044L27.3087 23.3881L25.8333 24.8635L24.8496 23.8799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3898 26.3394L23.8653 24.8639L24.849 25.8475L23.3735 27.323L22.3898 26.3394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3739 22.4045L24.8494 20.9291L25.833 21.9127L24.3576 23.3882L23.3739 22.4045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.915 24.8638L22.3905 23.3883L23.3742 24.372L21.8987 25.8474L20.915 24.8638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8564 11.0933L20.9219 7.15867L21.9055 6.17502L25.8401 10.1096L24.8564 11.0933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9208 10.1099L19.4453 8.6344L20.4289 7.65078L21.9044 9.12625L20.9208 10.1099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3799 12.5696L21.9044 11.0941L22.888 10.1105L24.3635 11.586L23.3799 12.5696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8711 7.15845L22.3956 5.68298L23.3793 4.69932L24.8548 6.17479L23.8711 7.15845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3319 9.61865L24.8564 8.14319L25.8401 7.15953L27.3156 8.63499L26.3319 9.61865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 22.4019L9.60646 26.3364L8.6228 27.3201L4.68822 23.3855L5.67188 22.4019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60651 23.3845L11.082 24.86L10.0984 25.8436L8.62289 24.3681L9.60651 23.3845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14746 20.926L8.62293 22.4015L7.63927 23.3851L6.1638 21.9097L7.14746 20.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62286 19.4502L12.5575 23.3848L11.5738 24.3684L7.63921 20.4339L8.62286 19.4502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60632 5.67993L5.67174 9.61452L4.68808 8.63086L8.62267 4.69627L9.60632 5.67993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0818 7.15527L7.1472 11.0899L6.16354 10.1062L10.0981 6.17162L11.0818 7.15527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5587 8.63159L8.62407 12.5662L7.64045 11.5826L11.575 7.64798L12.5587 8.63159Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSouthKorea);
export default __webpack_public_path__ + "static/media/flag_south_korea.9d3aeca4824a530341892ded55798405.svg";
export { ForwardRef as ReactComponent };